/**
 * @description logo
 * @author duanjun
 * @date
 */

import { getModuleData } from '../services/businessCommonService';
import { getData } from '@umu/umu-util';
import React from 'react';
import { PreImg } from './preImg/preImg';
import { IContextInfo, ICreatorInfo, IUserInfo } from '@umu/umu-types';
import * as imageUtil from '@umu/umu-image-handle';
import { getLogoStyle } from 'common/src/services/util';

import DEFAULT_LOGO_URL from '../images/logo.png';

type PropsType = {
    customizedLogo?: string;
};

export default class Logo extends React.Component<PropsType, { imgStyle: any }> {
    constructor(props: PropsType) {
        super(props);
        this.state = { imgStyle: { visibility: 'hidden' } };
    }

    public componentDidMount() {
        if (!this.props.customizedLogo) {
            return;
        }

        const logoUrl = this.getLogoUrl(this.props.customizedLogo);
        if (!logoUrl) {
            return;
        }
        getLogoStyle(logoUrl, (style) => {
            this.setState({ imgStyle: style });
        });
    }

    /**
     * getLogoUrl
     * 获取图片加参数
     */
    public getLogoUrl(url: string) {
        return imageUtil.appendWidth(url, 200);
    }

    public getLogoFromContextInfo() {
        const contextInfo = getModuleData('contextInfo') as IContextInfo;
        const userInfo = getModuleData('userInfo') as IUserInfo;
        const companyLogo =
            getData(contextInfo, 'enterprise_info', 'logo_mobile') ||
            getData(userInfo, 'enterprise_info', 'logo_mobile');
        const personalLogo = getData(contextInfo, 'personal_logo');
        return {
            companyLogo,
            personalLogo,
        };
    }
    private getLogoFromCreatorInfo() {
        const contextInfo = getModuleData('creatorInfo') as ICreatorInfo;
        const companyLogo = getData(contextInfo, 'enterprise_info', 'logo_mobile');
        return {
            companyLogo,
            personalLogo: '',
        };
    }
    private getAdaptedLogo() {
        const { companyLogo: logoCompanyFromContext, personalLogo: logoPersonalFromContext } =
            this.getLogoFromContextInfo();
        const { companyLogo: logoCompanyFromPersonal, personalLogo: logoPersonalFromPersonal } =
            this.getLogoFromCreatorInfo();
        return {
            companyLogo: logoCompanyFromContext || logoCompanyFromPersonal,
            personalLogo: logoPersonalFromContext || logoPersonalFromPersonal,
        };
    }
    public render() {
        const { companyLogo, personalLogo } = this.getAdaptedLogo();
        let logoUrl = companyLogo || DEFAULT_LOGO_URL;

        if (this.props.customizedLogo) {
            logoUrl = this.getLogoUrl(this.props.customizedLogo);
            return (
                <PreImg>
                    <img src={logoUrl} alt="UMU-CUSTOM" style={this.state.imgStyle} />
                </PreImg>
            );
        }
        // 企业版本logo优先, 个人垫后
        if (companyLogo) {
            logoUrl = this.getLogoUrl(companyLogo);
            return (
                <PreImg>
                    <img src={logoUrl} alt="UMU-CUSTOM" />
                </PreImg>
            );
        } else if (personalLogo) {
            logoUrl = this.getLogoUrl(personalLogo);
            return (
                <PreImg>
                    <img src={logoUrl} alt="UMU-PERSONAL" />
                </PreImg>
            );
        }

        return (
            <PreImg>
                <img src={logoUrl} alt="UMU" />
            </PreImg>
        );
    }
}
